import {
  TechRadarApi,
  TechRadarLoaderResponse,
} from '@backstage-community/plugin-tech-radar';

export class TechRadarClient implements TechRadarApi {
  async load(): Promise<TechRadarLoaderResponse> {
    return {
      rings: [
        { id: '0', name: 'BEGINNER', color: '#93c47d' },
        { id: '1', name: 'NOVICE', color: '#93d2c2' },
        { id: '2', name: 'PRO', color: '#fbdb84' },
        { id: '3', name: 'VISIONARY', color: '#fbdb84' },
      ],
      quadrants: [
        { id: '0', name: 'CORE' },
        { id: '1', name: 'CLOUD' },
        { id: '2', name: 'AGILE' },
        { id: '3', name: 'INFRASTRUCTURE-AS-CODE' },
      ],
      entries: [],
    };
  }
}
